module.exports = __webpack_public_path__ + "static/mattress-4-7550056f8262931409f621232c1a8a73.jpg";